var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-line")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-column-select", {
                    attrs: { model: _vm.model, browse: _vm.browse },
                    model: {
                      value: _vm.line.Prop,
                      callback: function ($$v) {
                        _vm.$set(_vm.line, "Prop", $$v)
                      },
                      expression: "line.Prop",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("pre-text"),
                      icon: "font",
                    },
                    on: {
                      "icon-click": function ($event) {
                        return _vm.editPreTextStyle()
                      },
                    },
                    model: {
                      value: _vm.line.PreText,
                      callback: function ($$v) {
                        _vm.$set(_vm.line, "PreText", $$v)
                      },
                      expression: "line.PreText",
                    },
                  }),
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("post-text"),
                      icon: "font",
                    },
                    on: {
                      "icon-click": function ($event) {
                        return _vm.editPostTextStyle()
                      },
                    },
                    model: {
                      value: _vm.line.PostText,
                      callback: function ($$v) {
                        _vm.$set(_vm.line, "PostText", $$v)
                      },
                      expression: "line.PostText",
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      attrs: { icon: "font" },
                      on: {
                        click: function ($event) {
                          return _vm.editPropStyle()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("edit-prop-style")))]
                  ),
                  _c(
                    "w-button",
                    {
                      attrs: { icon: "font" },
                      on: {
                        click: function ($event) {
                          _vm.editContainerStyle = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("edit-line-style")))]
                  ),
                  _vm.isNumber
                    ? [
                        _c("w-checkbox", {
                          attrs: {
                            value: _vm.line.PropRounding != null,
                            label: _vm.$ct("enable-rounding"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.toggleRounding($event)
                            },
                          },
                        }),
                        _c("w-input-number", {
                          attrs: {
                            label: _vm.$ct("round-on-decimals"),
                            disabled: _vm.line.PropRounding == null,
                            fancy: "",
                            decimals: 0,
                          },
                          model: {
                            value: _vm.line.PropRounding,
                            callback: function ($$v) {
                              _vm.$set(_vm.line, "PropRounding", $$v)
                            },
                            expression: "line.PropRounding",
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
      _vm.toEditStyle
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-basic-text-style-editor", {
                attrs: {
                  value: _vm.toEditStyle,
                  "extra-actions": _vm.styleExtraActions,
                  "is-local-style": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setStyle($event)
                  },
                  close: function ($event) {
                    _vm.toEditStyleProp = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.editContainerStyle
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-style-editor", {
                attrs: {
                  "line-height-enabled": "",
                  "font-disabled": "",
                  value: _vm.line.Style,
                  "is-local-style": "",
                },
                on: {
                  input: function ($event) {
                    _vm.line.Style = $event
                  },
                  close: function ($event) {
                    _vm.editContainerStyle = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }